import { useState, useEffect } from "react";
import { LocalStorageUtil } from "../utils/LocalStorageUtil";
import { Navigate, useLocation } from "react-router-dom";

const EXCEPTION_LOCATIONS = ["/signup", "/SignUpPage", "/finparkRegistration", "/globaldashboard"];

export const AuthGuard = ({ children }: { children: React.ReactNode }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleContextMenu = (e: any) => {
      const anchor = e.target.closest("a");
      if (anchor && anchor.href) {
        const url = new URL(anchor.href);
        const pathname = url.pathname;

        // Copy current session to localStorage before new tab opens
        LocalStorageUtil.copySessionToLocal();

        // Set the target path for the new tab
        setTimeout(() => {
          LocalStorageUtil.setCurrentPathAsLastViewed(pathname);
        }, 100);
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    return () => document.removeEventListener("contextmenu", handleContextMenu);
  }, []);

  useEffect(() => {
    const checkAuth = () => {
      // Skip auth check for exception locations
      if (EXCEPTION_LOCATIONS.includes(location.pathname)) {
        setIsValid(true);
        setIsChecking(false);
        return;
      }

      const token = LocalStorageUtil.getItem("token");
      let isValidToken = false;
      try {
        if (token && token !== '""') {
          const parsedToken = JSON.parse(token);
          isValidToken = parsedToken && parsedToken.length > 0;
        }
      } catch (e) {
        isValidToken = false;
      }

      setIsValid(isValidToken);
      setIsChecking(false);
    };

    const timer = setTimeout(checkAuth, 1000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (isChecking) return <div>Loading...</div>;
  return isValid ? (
    <>{children}</>
  ) : (
    <Navigate to={EXCEPTION_LOCATIONS.includes(location.pathname) ? location.pathname : "/"} replace />
  );
};
